<template>
    <a
        :href="link"
        target="_blank"
        class="item"
    >
        <img
            :class="[
                'thumbnail',
                {'is-loaded' : isLoaded}
            ]"
            :src="img"
            @load="isLoaded = true"
            alt=""
        >
    </a>
</template>

<script>
export default {
    name: "Item",
    data(){
        return {
            isLoaded: false
        }
    },
    props: {
        img: String,
        link: String
    }
}
</script>

<style lang="scss" scoped>
    .item {
        display: block;
        position: relative;
        overflow: hidden;
        padding: 0 !important;
        box-shadow: none !important;
        flex-basis: 16.66%;

        @media screen and (max-width: 770px){
            flex-basis: 33.33%;
        }
        @media screen and (max-width: 500px){
            flex-basis: 50%;
        }

        &::after {
            content: "";
            display: block;
            padding-bottom: 100%;
        }

        .thumbnail {
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            object-fit: cover;
            opacity: 0;
            transition: all 500ms;
            transform: scale(1.05);

            &:hover {
                transform: scale(1.1);
            }

            &.is-loaded {

                opacity: 1;

                &:hover {
                    opacity: 0.8;
                }

            }
        }
    }
</style>